import { PropsWithChildren } from 'react';
import {
  Box,
  Button,
  styled,
  Typography,
  TypographyProps,
  ButtonProps,
  BoxProps,
} from '@mui/material';

const Main = styled('main')(() => ({
  flex: 1,
  paddingTop: 28,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
}));

const Container = styled(Box)(() => ({
  flex: 1,
  maxWidth: 632,
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'center',
}));

const Image = styled('img')(() => ({
  width: '100%',
  maxWidth: '70%',
}));

const Footer = styled(Box)(({ theme }) => ({
  maxHeight: 81,
  padding: 16,
  borderTopWidth: 1,
  width: '-webkit-fill-available',
  display: 'flex',
  justifyContent: 'center',
  borderTopStyle: 'solid',
  borderTopColor: theme.palette.border.main,
}));

type Props = {
  title: {
    value?: string;
  } & TypographyProps;
  subTitle: {
    value?: string;
  } & TypographyProps;
  image?: string;
  button?: ButtonProps;
  footer?: BoxProps;
} & PropsWithChildren;

export default function SurveyDefaultStep({
  title: {
    value: titleValue,
    fontSize: titleFontSize = 36,
    fontWeight: titleFontWeight = 700,
    lineHeight: titleLineHeight = '40px',
    color: titleColor = 'black',
  } = {},
  subTitle: {
    value: subTitleValue,
    fontWeight: subTitleWeight = 600,
    lineHeight: subTitleLineHeight = '20px',
    color: subTitleColor = '#4E4F52',
  } = {},
  image,
  button,
  footer,
  children,
}: Props) {
  return (
    <Main>
      <Container>
        <Box gap={2} paddingInline={2} display="flex" flexDirection="column">
          <Typography
            fontSize={titleFontSize}
            fontWeight={titleFontWeight}
            lineHeight={titleLineHeight}
            color={titleColor}
          >
            {titleValue}
          </Typography>
          <Typography
            fontWeight={subTitleWeight}
            lineHeight={subTitleLineHeight}
            color={subTitleColor}
          >
            {subTitleValue}
          </Typography>
        </Box>
        {image ? (
          <Box flex={1} display="flex" alignItems="center" justifyContent="center">
            <Image src={image} />
          </Box>
        ) : (
          children
        )}
      </Container>
      {button && (
        <Footer {...footer}>
          <Button
            variant="contained"
            size="large"
            {...button}
            sx={{ maxWidth: 600, width: '100%' }}
          >
            Continue
          </Button>
        </Footer>
      )}
    </Main>
  );
}
